<template lang="pug">
    nav(aria-label="Breadcrumb" class="text-xs overflow-x-auto whitespace-nowrap lg:container")
        template(v-for="(crumb,index) in crumbs")
            nuxt-link(
                :to="linkBuilder(crumb.urlData)"
                :aria-current="index == crumbs.length-1 ? 'page' : false"
                v-html="crumb.title"
                class="addSlash text-gray-dark hover:no-underline"
            )
        script(type="application/ld+json" v-html="getSchema()")

</template>
<script>
import { linkBuilders } from '@/helpers/mixins'

export default {
    mixins: [linkBuilders],
    props: {
        crumbs: {
            type: Array,
            required: true,
        },
    },
    methods: {
        getSchema() {
            const obj = {
                '@context': 'http://schema.org',
                '@type': 'BreadcrumbList',
                itemListElement: [],
            }

            this.crumbs.forEach((crumb, index) => {
                obj.itemListElement.push({
                    '@type': 'ListItem',
                    position: index + 1,
                    item: {
                        '@id':
                            'https://' +
                            this.$sitewideData.domain +
                            this.$router.resolve(this.linkBuilder(crumb.urlData)).href,
                        name: crumb.title,
                    },
                })
            })

            return JSON.stringify(obj)
        },
    },
}
</script>

<style scoped lang="stylus">
.addSlash + .addSlash::before
    display inline-block
    margin 0 0.25em
    transform rotate(15deg)
    border-right 0.1em solid
    height 0.8em
    content ""
    padding-left: .25rem
    margin-right: .25rem
</style>
